export const getReminderAnalysesData = state => state.reminderAnalyses.all;
export const getReminderAnalysisData = state => state.reminderAnalyses.reminderAnalysis;
export const reminderAnalysesIsFetching = state => state.reminderAnalyses.loading.all;
export const reminderAnalysisIsFetching = state => state.reminderAnalyses.loading.reminderAnalysis;
